import { put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import { checkLocationSearchSelector } from 'selectors'
import { CHECK_LOCATION_SEARCH } from 'actions/uiActionTypes'
import { updateUiAction } from 'actions/uiActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function * checkLocationSearch(action) {
  try {
    const { offline, projectEdited } = yield select(checkLocationSearchSelector)

    if (!offline && projectEdited) yield put(updateUiAction({ modal: 'NewProjectAtLocation' }))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchCheckLocationSearch() {
  yield * takeEvery(CHECK_LOCATION_SEARCH, checkLocationSearch)
}



// WEBPACK FOOTER //
// ./src/sagas/checkLocationSearchSaga.js